export const environment = {
  production: false,
  profileName : 'local',
  env: 'stage',
  isGroupVisible: true,
  // phase 1 ships subscriptions for admins only; flips on when managers get access
  isManagerSubscriptionsVisible: false,

  // Callan online lessons server url
  apiEndpoint: 'https://api.lessons.stage.callanworks.co.uk/api',

  // Casa server
  authEndpoint: 'https://casa-dev.callanonline.com',
  casaEndpoint: 'https://casa-dev.callanonline.com',

  serverBase: 'https://admin.callanworks.co.uk',

  // Video server
  // Stage Env
  videoApiBase: 'https://api.video.stage.callanworks.co.uk/api',
  videoWebBase: "https://video.callanworks.co.uk",

  // transactions endpoint
  transApiBase: 'https://trans.callanworks.co.uk/api',

  // events endpoint
  eventsApiBase: 'https://stage.events.callan.app/api',

  // analytics
  analyticsUA: 'UA-69580833-1',
  adsTrackingCode: 'AW-977652603',
  adsTransactionLabel: 'XSmtCOa28JoBEPuWl9ID',

  casaClientId: 'usadh8yh0h23h9hHA8h3vlz0sf8sdhvAFHf9yhf9joascnasdu9',
  callanonlineId: 1,
  // to remove
  // casaRoot: 'http://casa-dev.callanonline.com',
  // casaRoot: "http://localhost:8080/ROOT"
  callanAppUrl: null,
  sentryTarget: "https://admin.callanworks.co.uk",
  logToSentry: true,
  awsBase: 'https://s3.amazonaws.com'
};
